// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".correct-images-match-picker[data-v-1dc5568e]{display:flex;flex-direction:column;align-items:flex-end;width:100%;position:relative}.correct-match[data-v-1dc5568e]{width:60%;font-weight:700;font-size:1rem;color:#0f2345;margin-bottom:10px}.actions[data-v-1dc5568e]{display:none;justify-content:center;align-items:center;margin-top:10px;width:100%}", ""]);
// Exports
module.exports = exports;
